import request from '@/utils/request'

// 公告列表
export function listPage(data) {
  return request({
    url: 'admin/data/schedule/list',
    method: 'post',
    data
  })
}

// 详情
export function info(id) {
  return request({
    url: 'admin/data/schedule/info/' + id,
    method: 'get'
  })
}

// 公告列表
export function dutyInfo(id) {
  return request({
    url: 'admin/data/schedule/dutyInfo/' + id,
    method: 'get'
  })
}

// 企业排班表提交
export function saveOrUpdateDuty(data) {
  return request({
    url: 'admin/data/schedule/saveOrUpdateDuty',
    method: 'post',
    data
  })
}
export function saveImportList(data) {
  return request({
    url: 'admin/data/schedule/importData',
    method: 'post',
    data
  })
}
